/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assistant_Saved_Prompt_Save_FailedInputs */



/**
* | output |
* | --- |
* | "Couldn't save the prompt. Check your connection and try again." |
*
* @param {Assistant_Saved_Prompt_Save_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const assistant_saved_prompt_save_failed = /** @type {((inputs?: Assistant_Saved_Prompt_Save_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assistant_Saved_Prompt_Save_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'enregistrer l'invite. Vérifiez votre connexion et réessayez.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Eingabeaufforderung konnte nicht gespeichert werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile salvare il prompt. Controlla la connessione e riprova.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось сохранить запрос. Проверьте подключение и повторите попытку.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo guardar la solicitud. Comprueba tu conexión e inténtalo de nuevo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("无法保存提示。请检查网络连接后重试。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロンプトを保存できませんでした。接続を確認して、もう一度お試しください。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रॉम्प्ट सहेजा नहीं जा सका। अपना कनेक्शन जाँचें और फिर से प्रयास करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foi possível guardar o prompt. Verifique a ligação e tente novamente.")
	return /** @type {LocalizedString} */ ("Couldn't save the prompt. Check your connection and try again.")
});